<template>
  <el-dialog
    :title="title"
    :visible.sync="visible"
    :before-close="() => this.onClose(false)">
    <span>{{ message }}</span>
    <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="() => this.onClose(true)">{{ confirmBtn || $t('GENERAL_acceptBtn') }}</el-button>
      <el-button class="btnConfirm" @click="() => this.onClose(false)">{{ cancelBtn || $t('GENERAL_cancelBtn') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>

  export default {
    name: 'Dialog',
    props: {
      visible: Boolean,
      title: String,
      message: String,
      cancelBtn: String,
      confirmBtn: String,
      onClose: Function
    }
  }

</script>

<style>

  .el-dialog {
    max-width: 700px;
  }

  .el-dialog__body {
    word-break: break-word;
  }

  @media(max-width: 400px)
  {
    .el-dialog__title {
      font-size: 16px !important;
    }
  }

  @media(max-width: 360px)
  {
    .el-dialog__footer button {
      width: 100%;
    }

    .el-dialog__footer button.btnConfirm {
      margin-left: 0px;
      margin-top: 10px;
    }
  }

</style>